import { Component } from '@angular/core';
import { UIGridBaseComponent } from 'app/ui/ui-grid-base.component';

@Component({
	selector: 'app-alert-list',
	templateUrl: './alert-list.component.html'
})
export class AlertListComponent extends UIGridBaseComponent {

}
